module.exports = __webpack_public_path__ + "img/huace4.85066297.jpg";